import "stylesheets/comments.scss";
import "src/decidim/comments/comments";
